import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.scss'],
    standalone: false
})
export class PaymentSuccessComponent implements OnInit {
  orderDetail: any = {};
  constructor(private router: Router, private sharedService: SharedService, private statePersist: StatePersistService) { }

  ngOnInit(): void {
    // 1️⃣ SCRAPE THE TRANSACTION ID DIRECTLY FROM THE REDIRECT URL PARAMETERS
    const urlParams = new URLSearchParams(window.location.search);
    const dynamicTransactionId = urlParams.get('paymentId'); 

    // 2️⃣ RETRIEVE YOUR PRE-SAVED MAGENTO ORDER SNAPSHOT FROM STORAGE
    const cachedDetails = localStorage.getItem('order-detail');

    if (cachedDetails) {
      this.orderDetail = JSON.parse(cachedDetails);
      
      // Merge the active 3DS transaction parameters into the final display array
      this.orderDetail["transaction_payment_id"] = dynamicTransactionId || 'pay_3ds_verified_' + this.orderDetail['order_id'];
      this.orderDetail['transaction_date'] = `${new Date().getDate()} ${new Date().toLocaleDateString('en-GB', { month: 'short' })},${new Date().getFullYear()}`; // Return landing time

      console.log('✅ [3DS Restored Successfully] Final Combined Payload:', this.orderDetail);

      // Update your central app state service layout with the recovered array
      this.statePersist.setLocalStorage('order-detail', this.orderDetail);
 
    } else {
      // Normal path fallback for non-3DS cards that update state values instantly
      this.orderDetail = this.statePersist.getLocalStorage('order-detail') || {};
    }
    try {
      if (window.opener && !window.opener.closed) {
        console.log('Pop-up context identified. Redirecting parent tab window focus...');
        window.opener.location.href = '/mycart/order-confirmation';
        window.opener.focus();
        window.close(); // Shut down the pop-up window gracefully
      } else {
        console.log('Inline frame path identified. Switching application route...');
        this.router.navigate(['mycart/order-confirmation']);
      }
    } catch (error) {
      console.warn('Cross-origin restriction handled. Forcing location override redirection:', error);
      window.top.location.href = '/mycart/order-confirmation';
    }

    this.miniCartDetails();
  }

  miniCartDetails() {
    this.sharedService.getminiCart()
      .subscribe(
        response => {
        }
      );
  }

}
